(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jetspeed-listings"] && !Shopify.designMode) return;
  try {
    const setJetspeedInquiryWatch = (title) => {
    const input = document.querySelector('#inquire input[name="contact[watch_or_reference]"]');
    if (!input || !title) return;
    input.value = title;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-watch-inquiry]');
    if (!trigger) return;
    setJetspeedInquiryWatch(trigger.dataset.watchTitle);
    requestAnimationFrame(() => {
      const input = document.querySelector('#inquire input[name="contact[watch_or_reference]"]');
      if (input) input.focus({ preventScroll: true });
    });
  });

  const requestedWatch = new URLSearchParams(window.location.search).get('watch');
  setJetspeedInquiryWatch(requestedWatch);
  } catch(e) { console.error(e); }
})();

})();
